import React from 'react';
import { AdminLayout } from '@/components/admin/layout/AdminLayout';
import { Button } from '@/components/ui/button';
import { Loader2, RefreshCw } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { AccessDenied } from '@/components/admin/verifications/AccessDenied';
import { ErrorState } from '@/components/admin/verifications/ErrorState';
import { VerificationCard } from '@/components/admin/verifications/VerificationCard';
import { useVerifications } from '@/hooks/verifications/useVerifications';
import { useAdminStatus } from '@/hooks/useAdminStatus';

const PEOVerifications = () => {
  const { user } = useAuth();
  const { isSuperAdmin, isLoading: isAdminLoading } = useAdminStatus();
  
  const {
    verifications,
    isLoading,
    error,
    refetch,
    processingId,
    handleVerification
  } = useVerifications(isSuperAdmin);

  if (!isSuperAdmin) {
    return (
      <AdminLayout>
        <AccessDenied />
      </AdminLayout>
    );
  }

  if (isLoading || isAdminLoading) {
    return (
      <AdminLayout>
        <div className="flex items-center justify-center h-64">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
        </div>
      </AdminLayout>
    );
  }

  if (error) {
    return (
      <AdminLayout>
        <ErrorState error={error instanceof Error ? error : null} onRetry={refetch} />
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <div className="space-y-6">
        <div className="flex justify-between items-center">
          <h1 className="text-3xl font-bold">PEO Provider Verifications</h1>
          <Button 
            variant="outline"
            onClick={() => refetch()}
            disabled={isLoading}
          >
            <RefreshCw className={`h-4 w-4 mr-2 ${isLoading ? 'animate-spin' : ''}`} />
            Refresh
          </Button>
        </div>

        <div className="grid gap-4">
          {verifications?.length === 0 ? (
            <div className="text-center py-8 text-muted-foreground">
              No pending verifications
            </div>
          ) : (
            verifications?.map((verification) => (
              <VerificationCard
                key={verification.id}
                verification={verification}
                onVerify={handleVerification}
                processingId={processingId}
              />
            ))
          )}
        </div>
      </div>
    </AdminLayout>
  );
};

export default PEOVerifications;
